(function (){
    'use strict';

    angular
        .module('services')
        .service('PaginationService', PaginationService);

    PaginationService.$inject = ['$http', 'API_BASE'];

    function PaginationService ($http, API_BASE) {
        var service = this;

        service.pageChanged        = pageChanged;


        function pageChanged (route) {
            return $http.get(route);
        }

    }
})();